import React from 'react';

import { withRouter } from 'react-router-dom';
import Suspense from '../../Common/components/Suspense-component';

import { getOrderDetails } from '../epics-orders';
import { getUserStatus } from '../../Users/epics-users';
import OrderDetails from '../component-order-details';

class OrderDetailsPage extends React.Component {
  getSingleOrder = () => {
    return getOrderDetails(this.props.match.params.orderId);
  };
  
  render() {
    return (
      <Suspense
        apiCalls={{
          orderDetails: this.getSingleOrder,
          userStatus: getUserStatus
        }}
      >
        <OrderDetails />
      </Suspense>
    );
  }
}

export default withRouter(OrderDetailsPage);



// WEBPACK FOOTER //
// ./src/customModules/Orders/containers/container-order-details.js